<template>
    <b-container class="rounded-lg">
        <b-form @submit.stop.prevent="submitHandler">
            <b-row >
                <b-col>
                    <label class="text-muted"><small>Add Note</small></label>
                    <b-form-input
                        v-model="note.message" 
                        placeholder="Note" 
                        outlined 
                        class="white"
                    />
                </b-col>
            </b-row>
        </b-form>
        <hr />
        <b-row class="mt-3">
          <b-col>
            <b-btn variant="outline-dark rounded-lg" @click="closeSidebar()">ANNULER</b-btn>
            <b-btn 
              class="ml-2 rounded-lg" 
              variant="primary" :disabled="loading"
              @click="submitHandler()">
              
              SAVE
              <b-spinner v-if="loading" small label="Loading..."></b-spinner>
            </b-btn>

            <b-btn variant="danger" class="float-right" @click="deleteNote()">
              <font-awesome-icon :icon="['fas', 'trash']" />
            </b-btn>
          </b-col>
        </b-row>
    </b-container>
</template>

<script>
import {ProjectMixin, GMapDrawingMixin} from '@/mixins';
import CesiumManager from '@/utils/CesiumManager';
export default {
    name: 'NoteForm',
    mixins: [ProjectMixin, GMapDrawingMixin],
    props: ['note', 'afterNoteCreate'],
    data(){
        return {
            loading: false
        }
    },

    methods: {
        submitHandler(){
          const payload = {
              note: {
                  message: this.note.message,
                  coords: this.note.coords,
                  section_id: this.note.section_id
              }
          }
          this.loading = true

          if(this.note.id.includes('temp')){
            this.$store.dispatch('notes/create',{ projectId: this.projectId, payload: payload }).then(res=>{
              console.log(this.note)
              let shape = this.$store.getters['notes/shapes'].filter(x => x.id == this.note.id)[0]
              if(shape){
                shape.setOptions({id: res.data.data.id, message: res.data.data.message})

                this.afterNoteCreate(shape)
              }
              this.closeSidebar()
            }).catch(err=>{
                alert(err)
            }).finally(()=>{
              this.loading = false
            })
          } else {
            this.$store.dispatch('notes/update',{ projectId: this.projectId, id: this.note.id, payload: payload }).then(res=>{
              console.log(this.note)
              let shape = this.$store.getters['notes/shapes'].filter(x => x.id == this.note.id)[0]
              if(shape){
                shape.setOptions({message: res.data.data.message})
              }
              this.closeSidebar()
            }).catch(err=>{
                alert(err)
            }).finally(()=>{
              this.loading = false
            })
          }
        },

        deleteNote(){
          if(confirm('Are you sure?')){
            this.$store.dispatch('notes/delete', { projectId: this.projectId, id: this.note.id }).then(res => {
              let shape = this.$store.getters['notes/shapes'].filter(x => x.id == this.note.id)[0]
              if(shape){
                shape.setMap(null)
              }
              const layerManger = CesiumManager.getLayerManager()
              if(layerManger){
                layerManger.removeNoteLayer(this.note.id, (shape) => {
                  this.$eventbus.$emit('onNoteMarkerClick', shape);
                })
              }
              this.closeSidebar()
            })
          }
        }
    }
}
</script>